 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLCH00_FM01_HALF from '@/components/xhtml/ch00_fm01_half'
 import XHTMLCH00_FM02_AUT from '@/components/xhtml/ch00_fm02_aut'
 import XHTMLCH00_FM03_TIT from '@/components/xhtml/ch00_fm03_tit'
 import XHTMLCH00_FM04_COPY from '@/components/xhtml/ch00_fm04_copy'
 import XHTMLCH00_FM05_DED from '@/components/xhtml/ch00_fm05_ded'
 import XHTMLCH00_FM06_PRE1 from '@/components/xhtml/ch00_fm06_pre1'
 import XHTMLCH00_FM07_CONT from '@/components/xhtml/ch00_fm07_cont'
 import XHTMLCH00_FM08_PRE from '@/components/xhtml/ch00_fm08_pre'
 import XHTMLCH00_FM09_ACK from '@/components/xhtml/ch00_fm09_ack'
 import XHTMLCH00_FM10_HALF1 from '@/components/xhtml/ch00_fm10_half1'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH02A from '@/components/xhtml/ch02a'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH03_PART01 from '@/components/xhtml/ch03_part01'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH06_PART02 from '@/components/xhtml/ch06_part02'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH09_PART03 from '@/components/xhtml/ch09_part03'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLCH11_EPI from '@/components/xhtml/ch11_epi'
 import XHTMLCH12_NOTES from '@/components/xhtml/ch12_notes'
 import XHTMLCH13_PHOTO from '@/components/xhtml/ch13_photo'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/ch00_fm01_half",
 			"name" : "xhtml/ch00_fm01_half",
 			"component" : XHTMLCH00_FM01_HALF
 		},
 		{
 			"path" : "/xhtml/ch00_fm02_aut",
 			"name" : "xhtml/ch00_fm02_aut",
 			"component" : XHTMLCH00_FM02_AUT
 		},
 		{
 			"path" : "/xhtml/ch00_fm03_tit",
 			"name" : "xhtml/ch00_fm03_tit",
 			"component" : XHTMLCH00_FM03_TIT
 		},
 		{
 			"path" : "/xhtml/ch00_fm04_copy",
 			"name" : "xhtml/ch00_fm04_copy",
 			"component" : XHTMLCH00_FM04_COPY
 		},
 		{
 			"path" : "/xhtml/ch00_fm05_ded",
 			"name" : "xhtml/ch00_fm05_ded",
 			"component" : XHTMLCH00_FM05_DED
 		},
 		{
 			"path" : "/xhtml/ch00_fm06_pre1",
 			"name" : "xhtml/ch00_fm06_pre1",
 			"component" : XHTMLCH00_FM06_PRE1
 		},
 		{
 			"path" : "/xhtml/ch00_fm07_cont",
 			"name" : "xhtml/ch00_fm07_cont",
 			"component" : XHTMLCH00_FM07_CONT
 		},
 		{
 			"path" : "/xhtml/ch00_fm08_pre",
 			"name" : "xhtml/ch00_fm08_pre",
 			"component" : XHTMLCH00_FM08_PRE
 		},
 		{
 			"path" : "/xhtml/ch00_fm09_ack",
 			"name" : "xhtml/ch00_fm09_ack",
 			"component" : XHTMLCH00_FM09_ACK
 		},
 		{
 			"path" : "/xhtml/ch00_fm10_half1",
 			"name" : "xhtml/ch00_fm10_half1",
 			"component" : XHTMLCH00_FM10_HALF1
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js